export default __webpack_public_path__ + "static/Inter-Variable-e05c5f3d1fa6a3893d84c1eef4e89951.ttf";